import Div from "@jumbo/shared/Div/Div";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";

// This is a fallback component when no data found for the searched request
const FallBackFormMessage = () => {
    const navigate = useNavigate(); // Initialize the useNavigate hook

    const redirectToCustomForm = () => {
        navigate("/docgen/custom-form"); // Navigate to the "/custom-form" route
    };

    return (
        <Div
            sx={{
                p: "100px 10px",
                backgroundColor: "#EFEFEF",
                color: "#000"
            }}
        >
            <p>No results found</p>
            <p>Try another search</p>
            <Div sx={{mb: "12px"}}>OR</Div>
            <Button
                sx={{
                    letterSpacing: "normal !important",
                    textTransform: "none !important",
                    p: "0 !important"
                }}
                variant="text"
                onClick={redirectToCustomForm}
            >
                Create New Custom Form
            </Button>
        </Div>
    );
};

export default FallBackFormMessage;